import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../requestOptions';

export interface AttributionHistoryEntry {
  entity_type: 'ai_suggestion' | 'manual_override';
  user: string | null;
  field: string | null;
  old_value: string | null;
  new_value: string | null;
  timestamp: string | null;
  subscription_id: number;
  suggestion_id: number;
  product_id: number;
  assignment_id: number;
}

interface AttributionHistoryResponse {
  data: AttributionHistoryEntry[];
}

export async function getAttributionHistoryForProduct(
  scope: RequestScope,
  args: { productId: number | string },
  options: ReadRequestOptions
): Promise<ChannelApiResponse<AttributionHistoryResponse>> {
  try {
    if (!args.productId) {
      throw new Error('Valid productId is required');
    }

    const res = await scopedChannelApi(scope).get<AttributionHistoryResponse>(`atts/acendaai/attribution_history/product/${args.productId}`, options);
    return { data: res.data, status: res.status };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
